import { delay, http, HttpResponse, HttpResponseResolver } from "msw";
import { ApiCatalog, API_BASE_URL } from "@/api";
import { teacherSchoolAffiliationSuccessResponseMock } from "./mutations.test.mock";
import type {
  SchoolAdminAffiliationResponse,
  TeacherSchoolAffiliationResponse,
} from "./mutations.type";

export const createTeacherSchoolAffiliationMutationHandler = ({
  defaultData,
  status,
  teacherUniqueId,
}: {
  defaultData?: TeacherSchoolAffiliationResponse | undefined;
  status?: number;
  teacherUniqueId: string;
}) => {
  const mockedResolver = jest.fn(async () => {
    await delay(100);
    return HttpResponse.json(
      defaultData || teacherSchoolAffiliationSuccessResponseMock,
      { status: status || 200 },
    );
  }) as unknown as jest.MockedFunction<HttpResponseResolver>;
  const path = ApiCatalog.teacherSchoolAffiliation.endpoint.replace(
    "[unique_id]",
    teacherUniqueId,
  );
  const post = http.post(`${API_BASE_URL}${path}`, mockedResolver);
  return {
    post,
    mockedResolver,
  };
};

export const createSchoolAdminSchoolAffiliationMutationHandler = ({
  defaultData,
  status,
  schoolAdminUniqueId,
}: {
  defaultData?: SchoolAdminAffiliationResponse | undefined;
  status?: number;
  schoolAdminUniqueId: string;
}) => {
  const mockedResolver = jest.fn(async () => {
    await delay(100);
    return HttpResponse.json(
      defaultData || teacherSchoolAffiliationSuccessResponseMock,
      { status: status || 200 },
    );
  }) as unknown as jest.MockedFunction<HttpResponseResolver>;
  const path = ApiCatalog.schoolAdminSchoolAffiliation.endpoint.replace(
    "[unique_id]",
    schoolAdminUniqueId,
  );
  const post = http.post(`${API_BASE_URL}${path}`, mockedResolver);
  return {
    post,
    mockedResolver,
  };
};
